import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import HeightPin from "../HeightPin";
import ScrollSection from "../ScrollSection";
import GemDiscover from "../elements/GemDiscover";
import MoodBoard from "../MoodBoard"
import ImageCirclePack from "../charts/ImageCirclePack";
import TreeMap from "../charts/TreeMap";
import CardFlip from "../elements/CardFlip";
import DidYouKnow from "../elements/DidYouKnow";
import SectionTop from "./SectionTop";
import ProgramPicker from "../ProgramPicker";

function CampusPriorities(props) {
    const {store, state, color, index, downhill, progress} = props;
    const {circlePackStore} = store;

    const group = 'CPR';
    const activeKey = store.activeSection(group) || 'CPR_1';


    const sectionY = 0.35;

    return (
        <div className={'Section'}>
            <SectionTop group={group} downhill={downhill}>
                <h4>
                  What campus needs are top priorities?
                </h4>
                <p>
                  The campus has a wide variety of goals and needs.
                </p>
                <p>
                  Campus planning supports decision-making about building and infrastructure investments by identifying and weighing trade-offs. Choices may be constrained by temporary space to accommodate people during construction (surge space), limited land resources, funding availability, phasing, competition for the same resources, and environmental considerations.
                </p>
                <p>
                  What do you think are the top priorities for campus investment?
                </p>
                <p className="photocredit">
                  Photo Credit: Steve McConnell
                </p>
            </SectionTop>
            <div className={'interactive right-sticky'}>
                <ProgramPicker store={store} color={color} index={index} state={state} progress={progress}/>
            </div>
        </div>
    );
}

export default observer(CampusPriorities);
